// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__RXGHB","imageUploader":"EGiftCard_imageUploader__1rpIg"};